var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "map__container" }, [
      _c("img", {
        staticClass: "map__img",
        attrs: { src: _vm.mapUrl, alt: "" },
        on: { click: _vm.imgDebug },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "map__point-container" },
        _vm._l(_vm.getCities(), function (point) {
          return _c(
            "div",
            { staticClass: "map__point", style: _vm.pointStyle(point) },
            [
              _c("div", { staticClass: "map__point-circle" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "map__point-name",
                domProps: { textContent: _vm._s(_vm.$t(point.name)) },
              }),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }